/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/switchAll */
import{switchMap as t}from"rxjs/dist/esm/internal/operators/switchMap";import{identity as i}from"rxjs/dist/esm/internal/util/identity";function m(){return t(i)}export{m as switchAll};
//# sourceMappingURL=switchAll.mjs.map